import React from "react";
import {inject, observer} from "mobx-react";
import configuration from "../../configuration/configuration";
import Diffusion from "./publicite/Diffusion";
import {diapositivesDe} from "./publicite/diaporama";

/**
 * Mode Publicité d'Aerith : le diaporama réglé dans le tableau de bord (page « Écran client », carte « Publicité ») ;
 * sans diapositive, l'accueil d'origine. Le diaporama change en direct quand il est enregistré.
 */
const ScreenMode = inject("rootStore")(observer(({rootStore}) => {
    const auth = rootStore.authStore;
    const diapositives = React.useMemo(() => diapositivesDe(auth.publicite), [auth.publicite]);
    const fondProps = id => ({
        images: (auth.fondImages[id] || []).map(image => configuration.API + image.url),
        reglages: auth.fondReglages[id],
        horaires: auth.fondHoraires,
    });

    return <Diffusion diapositives={diapositives} base={configuration.API} fondProps={fondProps}/>;
}));

export default ScreenMode;
